<template>
  <img
    v-if="qrCodeUrL"
    :src="qrCodeUrL"
    :class="{ margin: hasMargin }"
    class="qr-code"
  >
</template>

<script>
import { defineComponent, ref } from 'vue';
import qrcode from 'qrcode';
import useDynamicUrl from '@/composables/useDynamicUrl';

export default defineComponent({
  name: 'QrCodeComponent',

  props: {
    qrCodeData: {
      type: Object,
      default: null,
    },
    hasMargin: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const qrCodeUrL = ref('');

    if (props.qrCodeData) {
      qrcode.toDataURL(
        useDynamicUrl(props.qrCodeData.data),
        props.qrCodeData.options,
        (error, url) => {
          qrCodeUrL.value = url;
        },
      );
    }

    return {
      qrCodeUrL,
    };
  },
});
</script>

<style lang="scss" scoped>
.qr-code {
  width: 160px !important;
  position: relative;
  z-index: 1;

  &.margin {
    margin-bottom: 24px;
  }

  $sizes:
      $tablet_breakpoint 200px 20px,
      $desktop_s_breakpoint 162px 44px,
      $desktop_m_breakpoint 240px 52px,
      $desktop_l_breakpoint 320px 60px;

  @each $size, $width, $margin in $sizes {
    @media screen and (min-width: $size) {
      width: $width !important;

      &.margin {
        margin-bottom: $margin;
      }
    }
  }

  @media screen and (max-height: $mobile_height_breakpoint) {
    width: 112px !important;

    &.margin {
      margin-bottom: 20px;
    }
  }

  @media screen and (min-height: $big_vertical_screen_breakpoint) {
    width: 800px !important;

    &.margin {
      margin-bottom: 144px;
    }
  }
}
</style>
